module.exports = __webpack_public_path__ + "img/Small-Horizontal-Rectangular-Attachment-15.58598953.png";